import React from "react";
import { Tabs } from 'antd';

import serviceTabApi from "./AllTabContent";
const TabSection = ()=>{
  return (
    <div className="tab-section">
      <div className="container">
      <div className="tabs">
      <Tabs 
      defaultActiveKey="1"    
      items={serviceTabApi}
    />
  
      </div>
      </div>
    </div>
  )
}
export default TabSection;